import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import type { AutosaveStatus } from '../hooks/useDraftAutosave';

interface AutosaveIndicatorProps {
  status: AutosaveStatus;
}

export function AutosaveIndicator({ status }: AutosaveIndicatorProps) {
  if (status === 'idle') return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        minHeight: 20,
      }}
      aria-live="polite"
    >
      {status === 'saving' && (
        <>
          <CircularProgress size={12} />
          <Typography variant="caption" color="text.secondary">
            Saving...
          </Typography>
        </>
      )}
      {status === 'saved' && (
        <>
          <CheckIcon sx={{ fontSize: 14, color: 'success.main' }} />
          <Typography variant="caption" color="text.secondary">
            Saved
          </Typography>
        </>
      )}
      {status === 'error' && (
        <Typography variant="caption" color="error.main">
          Couldn&apos;t save your latest changes. We&apos;ll retry when you continue.
        </Typography>
      )}
    </Box>
  );
}
